import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class BeneficiaryGuardianCategory extends Enum {
  static PUBLIC = {
    key: 'public',
    get value() {
      return Lang.t('beneficiary.public-guardian');
    },
    get description() {
      return Lang.t("beneficiary.beneficiary-the-government");
    }
  };

  static PRIVATE = {
    key: 'private',
    get value() {
      return Lang.t('beneficiary.private-guardian');
    },
    get description() {
      return Lang.t(
        'beneficiary.beneficiary-or-private'
      );
    }
  };

  /**
   * @param key
   * @returns {boolean}
   */
  static isUnderPublicGuardianship(key) {
    return key === this.PUBLIC.key;
  }

  /**
   * @param key
   * @returns {boolean}
   */
  static isUnderPrivateGuardianship(key) {
    return key === this.PRIVATE.key;
  }
}
